import request from '../utils/request';

// Get customer links list
export function getCustomerLinksList(params) {
    return request({
        url: '/corp_links/get_links',
        method: 'get',
        params
    });
}

// Create customer link
export function createCustomerLink(data) {
    return request({
        url: '/corp_links/link_create',
        method: 'post',
        data
    });
}

// Update customer link name
export function updateCustomerLinkName(data) {
    return request({
        url: '/corp_links/link_update',
        method: 'post',
        data
    });
}

// Delete customer link
export function deleteCustomerLink(params) {
    return request({
        url: '/corp_links/link_delete',
        method: 'get',
        params
    });
}

// Get customer link detail
export function getCustomerLinkDetail(params) {
    return request({
        url: '/corp_links/link_detail',
        method: 'get',
        params
    });
}

// Get group list
export function getGroupList(params) {
    return request({
        url: '/corp_links/group_list',
        method: 'get',
        params
    });
}

// Create group
export function createGroup(data) {
    return request({
        url: '/corp_links/group_create',
        method: 'post',
        data
    });
}

// Update group
export function updateGroup(data) {
    return request({
        url: '/corp_links/group_update',
        method: 'post',
        data
    });
}

// Delete group
export function deleteGroup(params) {
    return request({
        url: '/corp_links/group_delete',
        method: 'get',
        params
    });
}
